import { ComponentProps, FC } from "react";

import { useTranslation } from "react-i18next";

import { Radio } from "@mantine/core";

import { RequiredLabel } from "@components/RequiredLabel/RequiredLabel";

export const EntityTypeInput: FC<
  Omit<ComponentProps<typeof Radio["Group"]>, "label" | "children">
> = (props) => {
  const { value } = props;
  const { t } = useTranslation();
  return (
    <Radio.Group
      label={<RequiredLabel label="Registree / Submitter" value={value} />}
      {...props}
    >
      <Radio label={t("Individual")} value="person" />
      <Radio label={t("Organization")} value="organization" />
      <Radio label={t("Company")} value="company" />
      <Radio label={t("Group")} value="group" />
    </Radio.Group>
  );
};
